import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BaseService } from "./base.service";

@Injectable({
  providedIn: "root",
})
export class ParticipantMessageService extends BaseService {
  constructor(protected readonly http: HttpClient) {
    super(http);
    this.setBaseUrl("ParticipantMessage");
  }

  unsubscribe(token: string): Observable<any> {
    return this.http.post<any>(this.buildUrl(`/Unsubscribe?token=${token}`), null);
  }

}
